<script setup lang="ts">
const props = defineProps<{
  message: string // HTML-Content als String
}>()
</script>

<template>
  <div class="finish-message">
    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="content is-medium">
            <div v-html="props.message" class="message-content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@import '../../../assets/main.css';

strong {
}
</style>
